( function( app ) {
  const COMPONENT = {
    init: function() {
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'hover-selector-list', COMPONENT );
} )( app );
